import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIArray, BaseApiService } from '../services/base-api.service';
import { HelpersService } from '../services/helpers.service';
import { ProgressService } from '../services/progress.service';
import { LoadingService } from '../services/loading.service';
import { share } from 'rxjs';
import { HttpQuery } from '../services/http-query';

@Injectable({
  providedIn: 'root',
})
export class CashAdvanceService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'cash-advance';
    this.query = { limit: 0, page: 0 };
  }

  override getById(id: string, query?: HttpQuery): Promise<any> {
    console.log('get id servis')
    return new Promise((resolve, reject) => {
      const url = this.url_array(['find', id]);
      this.loadingService.startLoading();
      this.http.get<any>(url).subscribe({
        next: ({ data }) => {
          console.log(data)
          this.currentData = data;
          this.loadingService.endLoading();
          return resolve(this.currentData);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  override updateById(id: string, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('update');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getAllClaimer(query?: HttpQuery, notifyChange: Boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('paginate');
      this.loadingService.startLoading();
      this.http.post<BaseAPIArray<any>>(url, query).subscribe({
        next: ({ data, meta }) => {
          this.data = data;
          this.dataLength = meta.totalData;
          if (notifyChange) {
            this.onDataChanged.next(this.data);
            this.onDataLengthChanged.next(this.dataLength);
          }
          this.loadingService.endLoading();
          return resolve(data);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  getCountStatus(): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['count', 'by-status']);
      this.loadingService.startLoading();
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getApprovalById(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom_id('find', id);
      this.loadingService.startLoading();
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getApprovalList(cashAdvanceId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/list');
      let params = new HttpParams();
      params = params.append('cashAdvanceId', cashAdvanceId);
      this.loadingService.startLoading();
      this.http
        .get<any>(url, { params })
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  approve(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/approve');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  reject(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approval/reject');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  submitSettlement(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('submit-settlement');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  resubmitSettlement(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('resubmit-settlement');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
}
